import { EnvironmentSettings } from '@twist/settings';

export const environment : EnvironmentSettings = {
  mqttBrokerUrl: 'ws://mqtt-dev.twist-innovation.com:9001',
  production: false,
  pageTitlePrefix: "[ DEV ] - ",
  backboneUrl: "https://backbone.dev.twist-innovation.com",
  manufacturingUrl: "https://manufacturing.dev.twist-innovation.com",
  ciamUrl: "https://auth-dev.twist-innovation.com",
  signalrUlr: "https://signalr.dev.twist-innovation.com",
  documentationRootUrl: "https://docs-dev.twist-innovation.com",
  features: {
    // Must match the backend's Loco:Enabled for this environment. On here
    // while the backend has it off shows a way in to endpoints that host
    // does not serve.
    loco: false
  },
  logging: {
    providers: {
      console: {
        enabled: true,
        level: 'TRACE'  // Console gets all logs in development
      },
      remote: {
        enabled: false,  // Remote logging disabled in development
        level: 'WARNING'  // But if enabled, only send warnings and above
      }
    }
  }
};
